import { NgModule, Directive } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { SolutionComponent } from './solution/solution.component';
import { ErrorComponent } from './solution/residential/404error.component';
import { Error503Component } from './solution/residential/503error.component';
import { Error400Component } from './solution/residential/400error.component';
import { Error500Component } from './solution/residential/500error.component';
import { ResidentialComponent } from './solution/residential/residential.component';

import { GetStartedComponent } from '../get-started/get-started.component';
// import { PathResolveService } from '../questionarie-signup/questionnaire-residential/path-resolve.service'

import { QuestionnaireResidentialComponent } from '../questionarie-signup/questionnaire-residential/questionnaire-residential.component';
import { DepositPendingStatus } from './solution/residential/deposit-pending-status.component';
const routes: Routes = [
  // { path: '',  redirectTo: '/about', pathMatch: 'full' },
  { path: '', component: AboutComponent },
  { path: 'residential', component: ResidentialComponent },
  { path: 'promo', component: AboutComponent },
  { path: 'about', component: AboutComponent },
  { path: 'solution', component: SolutionComponent },
  { path: 'get-started', component: GetStartedComponent },
  { path: 'residentialQues', component: QuestionnaireResidentialComponent },
  {
    path: 'residentialQues/add-address/:id',
    component: QuestionnaireResidentialComponent,
  },
  {
    path: 'residentialQues/renewal/:id',
    component: QuestionnaireResidentialComponent,
  },
  { path: 'errorfournotfourFound', component: ErrorComponent },
  { path: '503ErrorFound', component: Error503Component },
  { path: 'error400Found', component: Error400Component },
  { path: '500ErrorFound', component: Error500Component },
  { path: 'desosit-pending/:status', component: DepositPendingStatus },
];

@Directive()
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class HomeMainRoutingModule {
  constructor(private router: Router) {}

  ngOnInit() {
    // function userExists(username) {
    //     return this.router.config.some(function(el) {
    //       return el.path === username;
    //     });
    //   }
    // if(!userExists(window.location.href.split('/')[3])){
    //     this.router.navigate(['404ErrorFound']);
    // }
    // console.log(userExists(window.location.href.split('/')[3]));
    // //    for(var i = 0 ; i<= routes.length;i++){
    // //         if(routes[i].path != window.location.href.split('/')[3]){
    // //             this.router.navigate(['UrlNotFound']);
    // //         }
    // //    }
  }
}
